import { useEffect } from 'react';

export const useComponentUnmount = (componentUnmountCallback, deps = []) => {
    useEffect(() => {
        return () => componentUnmountCallback()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [...deps])
}
